module.exports = __webpack_public_path__ + "media/images/emblems/Horw_LU-dc982938e2bbf1612fc3266db4ef3443.png";